module.exports = __webpack_public_path__ + "img/gaokao.be78cff7.jpeg";